module.exports = __webpack_public_path__ + "static/post-four-dbac1d693589ca2a6501fa26913a46ff.png";